function notifyCart(t) {
    var a = $("#social-cart-num"),
        e = (a.offset().top, a.offset().left, $(t));
    $("body").append(e), $(e).hide(), $(e).fadeIn("slow", "easeInOutExpo", function() {
        var t = $(this).offset().top,
            a = $(this).offset().left;
        $(this).css({
            margin: 0,
            left: a,
            top: t,
            position: "absolute"
        }).delay(2e3).animate({
            top: 0,
            left: "auto",
            right: 0,
            opacity: 1
        }, 3e3, "easeInOutExpo", function() {
            $(this).remove()
        }), $(".product .product-wait").hide()
    })
}

function addToCart(t) {
    "undefined" != typeof t && t.preventDefault(), $("#umbrella .cart-loading").removeClass("hide");
    var a = $(this);
    a.parents(".product").find(".product-wait").show();
    var e = a.parents("form");
    window.allow_direct_cart ? e.submit() : $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        data: e.serialize(),
        dataType: "json",
        error: addToCartFail,
        success: addToCartSuccess,
        cache: !1
    }), $(".modal").modal("hide")
}

function addToCartSuccess(t, a, e) {
    $.ajax({
        type: "GET",
        url: "/cart.js",
        async: !0,
        cache: !1,
        dataType: "json",
        success: updateCartDesc
    });
    var o = '<div class="popupaddcart">Item added to Cart!</div>';
    notifyCart(o), Shopify.getCart(function(t) {
        Shopify.updateCartInfo(t, "cart-info")
    })
}

function addToCartFail(t, a, e) {
    var o = $.parseJSON(t.responseText),
        r = '<div class="popupaddcart">' + o.description + "</div>";
    notifyCart(r), $("#umbrella .cart-loading").addClass("hide")
}

function searchPlaceholder() {
    Modernizr.input.placeholder || ($("#top-search-input").focus(function() {
        var t = $(this);
        t.val() == t.attr("placeholder") && (t.val(""), t.removeClass("placeholder"))
    }).blur(function() {
        var t = $(this);
        ("" == t.val() || t.val() == t.attr("placeholder")) && (t.addClass("placeholder"), t.val(t.attr("placeholder")))
    }).blur(), $("[placeholder]").parents("form").submit(function() {
        $(this).find("[placeholder]").each(function() {
            var t = $(this);
            t.val() == t.attr("placeholder") && t.val("")
        })
    }))
}! function(t) {
    function a() {}
    for (var e, o = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","); e = o.pop();) t[e] = t[e] || a
}(function() {
    try {
        return console.log(), window.console
    } catch (t) {
        return window.console = {}
    }
}());
var GLOBAL = {
        common: {
            init: function() {
                $("html").removeClass("no-js").addClass("js"), searchPlaceholder(), $(".add-to-cart").bind("click", addToCart)
            }
        },
        templateIndex: {
            init: function() {}
        },
        templateProduct: {
            init: function() {}
        },
        templateCart: {
            init: function() {}
        }
    },
    UTIL = {
        fire: function(t, a, e) {
            var o = GLOBAL;
            a = void 0 === a ? "init" : a, "" !== t && o[t] && "function" == typeof o[t][a] && o[t][a](e)
        },
        loadEvents: function() {
            var t = document.body.id;
            UTIL.fire("common"), $.each(document.body.className.split(/\s+/), function(a, e) {
                UTIL.fire(e), UTIL.fire(e, t)
            })
        }
    };
$(document).ready(UTIL.loadEvents);